import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminData } from '../contexts/AdminDataContext';
 export default function Bases() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCircle, setSelectedCircle] = useState('all');
  
  // Use centralized admin data
  const { circles, bases, users, isLoading } = useAdminData();
  const bazna = circles;
  const supervisors = users;


  const handleEdit = (id) => {
    navigate(`/admin/base/edit/${id}`);
  };

  const handleAddBase = () => {
    navigate('/admin/base/add');
  };

  // Filter bases based on selected circle and search term
  const filteredBases = bases.filter(base => {
    const matchesCircle = selectedCircle === 'all' || base.circle_id == selectedCircle;
    const matchesSearch = base.base_name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          base.base_location?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCircle && matchesSearch;
  });

  // Get supervisors for a specific base
  const getBaseSupervisors = (baseId) => {
    return supervisors.filter(supervisor => supervisor.base_id == baseId);
  };

  if (isLoading.circles || isLoading.bases || isLoading.users) {
    return (
      <div className="page active">
        <div className="loading">لە هێنانی زانیارییەکان...</div>
      </div>
    );
  }

  return (
    <div className="page active">
      <div className="page-header">
        <h1>بنکەکان</h1>
        <p>بەڕێوەبردنی لیستی بنکەکان</p>
      </div>

      {/* Filters */}
      <div className="advanced-filters">
        <div className="filter-group">
          <label className="filter-label">بازنە:</label>
          <select 
            className="filter-select" 
            value={selectedCircle}
            onChange={(e) => setSelectedCircle(e.target.value)}
          >
            <option value="all">هەموو بازنەکان</option>
            {localStorage.getItem('role')==='admin' && bazna  && ( 
           <option key={bazna.id} value={bazna.id}>
           {bazna.circle_name}
         </option>
      
               )} 
            {localStorage.getItem('role')==='superadmin' && bazna.map((item) => (
              <option key={item.id} value={item.id}>{item.circle_name}</option>
            ))}
          </select>
        </div>

        {/* Search box */}
        <div className="filter-group">
          <label className="filter-label">گەڕان:</label>
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input 
              type="text" 
              placeholder="گەڕان لە بنکەکان..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Total count with original styling but positioned at bottom */}
        <div className="total-count-in-filters" style={{ alignSelf: 'flex-end' }}>
          <span className="count-badge">
            <i className="fas fa-building"></i>
            کۆی گشتی: {bases.length} بنکە
            {selectedCircle !== 'all' && (
              <span style={{ marginLeft: '10px', opacity: 0.8 }}>
                {/* | {bazna.find(b => b.id == selectedCircle)?.circle_name}: {filteredBases.length} */}
              </span>
            )}
          </span>
        </div>

        <div className="filter-group">
          <label className="filter-label" style={{ opacity: 0 }}>کردار:</label>
          <button className="add-btn" onClick={handleAddBase}>
            <i className="fas fa-plus"></i>
            زیادکردنی بنکە
          </button>
        </div>
      </div>

      {/* Bases Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
        {filteredBases.map((base) => {
          const baseSupervisors = getBaseSupervisors(base.id);
          
          return (
            <div key={base.id} className="base-card" style={{ padding: '20px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                  <h3 style={{ margin: '0 0 5px 0', color: '#1f2937', fontSize: '18px' }}>{base.base_name}</h3>
                  <p style={{ margin: '0 0 5px 0', color: '#6b7280', fontSize: '14px' }}>
                    {/* {bazna.find(circle => circle.id == base.circle_id)?.circle_name || 'نازانراو'} */}
                  </p>
                  <p style={{ margin: '0', color: '#9ca3af', fontSize: '12px' }}>{base.base_location}</p>
                </div>
                <button 
                  className="action-btn edit-btn" 
                  onClick={() => handleEdit(base.id)}
                  style={{ padding: '8px 12px' }}
                >
                  <i className="fas fa-edit"></i> دەستکاری
                </button>
              </div>

              <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '15px' }}>
                <div style={{ marginBottom: '10px' }}>
                  <h4 style={{ margin: '0', color: '#374151', fontSize: '14px' }}>چاودێران ({baseSupervisors.length})</h4>
                </div>
                
                {baseSupervisors.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {baseSupervisors.map((supervisor) => (
                      <div key={supervisor.id} style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        padding: '8px 12px',
                        background: '#f8fafc',
                        borderRadius: '6px',
                        fontSize: '13px'
                      }}>
                        <span style={{ fontWeight: '500', color: '#374151' }}>{supervisor.name}</span>
                        <span style={{ color: '#6b7280' }}>{supervisor.phone}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ 
                    margin: '0', 
                    color: '#9ca3af', 
                    fontSize: '13px', 
                    fontStyle: 'italic',
                    textAlign: 'center',
                    padding: '10px'
                  }}>
                    هیچ چاودێرێک تۆمار نەکراوە
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {filteredBases.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#7f8c8d' }}>
          <i className="fas fa-search" style={{ fontSize: '48px', marginBottom: '15px', display: 'block' }}></i>
          هیچ بنکەیەک نەدۆزرایەوە
        </div>
      )}
    </div>
  );
}